import { ApolloLink, Observable } from 'apollo-link'
import { getQueryDocumentKey } from 'persistgraphql'
import { fetchOptions } from 'src/services'

/**
 * Link responsible of fetching the persisted queries map from the server and using it to map queries from the client with the ID to send to the server
 *
 * Inspired by official link apollo-link-context
 * @see https://github.com/apollographql/apollo-link/blob/master/packages/apollo-link-context/src/index.ts
 */
export default () => {
  const queriesPromise = fetch('/queries', fetchOptions).then(response => response.json())

  return new ApolloLink((operation, forward) => {
    return new Observable(observer => {
      let handle

      queriesPromise
        .then(queryMap => {
          const { query, extensions } = operation

          const queryKey = getQueryDocumentKey(query)
          const persistedQueryId = queryMap[queryKey]

          if (!persistedQueryId) {
            throw new Error('Failed to find query in persisted query map.\n' + queryKey)
          }

          extensions.persistedQuery = {
            id: persistedQueryId,
          }

          // https://www.apollographql.com/docs/link/links/http.html#persisted-queries
          operation.setContext({
            http: {
              includeExtensions: true,
              includeQuery: false,
            },
          })

          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          })
        })
        .catch(observer.error.bind(observer))

      return () => {
        if (handle) handle.unsubscribe()
      }
    })
  })
}
